import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

export const FiltersWrapper = styled.div`
  margin: ${layout.spacing.xxSmall} 10px 0 10px;

  ${media.smallOnly`
    margin: 0;
  `};
`;
